interface BuildInfo {
  version: string;
  revision: string;
  builtAt: string | null;
}
// Replaced by Vite, including the exact GitHub deployment SHA when available.
declare const __SPELLIE_BUILD_INFO__: BuildInfo;
export const BUILD_INFO: BuildInfo =
  typeof __SPELLIE_BUILD_INFO__ === 'undefined'
    ? { version: 'dev', revision: 'local', builtAt: null }
    : __SPELLIE_BUILD_INFO__;
